import i18n from "@/i18n/i18n";

export function getAll() {
  return [
    {
      value: 0,
      name: "Today",
      text: `${i18n.global.t("enums.dateRange.today")}`,
    },
    {
      value: 1,
      name: "Yesterday",
      text: `${i18n.global.t("enums.dateRange.yesterday")}`,
    },
    {
      value: 2,
      name: "ThisWeek",
      text: `${i18n.global.t("enums.dateRange.thisWeek")}`,
    },
    {
      value: 3,
      name: "ThisMonth",
      text: `${i18n.global.t("enums.dateRange.thisMonth")}`,
    },
    {
      value: 4,
      name: "LastMonth",
      text: `${i18n.global.t("enums.dateRange.lastMonth")}`,
    },
    {
      value: 5,
      name: "ThisYear",
      text: `${i18n.global.t("enums.dateRange.thisYear")}`,
    },
    {
      value: 6,
      name: "LastYear",
      text: `${i18n.global.t("enums.dateRange.lastYear")}`,
    },
    {
      value: 7,
      name: "LastSevenDays",
      text: `${i18n.global.t("enums.dateRange.lastSevenDays")}`,
    },
    {
      value: 8,
      name: "LastThirtyDays",
      text: `${i18n.global.t("enums.dateRange.lastThirtyDays")}`,
    },
    // {
    //   value: 9,
    //   name: "Customize",
    //   text: `${i18n.global.t("enums.dateRange.customize")}`,
    // },
  ];
}
